<template>
  <div>
    <AchievementsHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">成果交易</a-breadcrumb-item>
        <a-breadcrumb-item>{{ type }}详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tradingBox">
      <div class="leftBox">
        <a-image :src="getImg(detail.achievementPicture)" alt="" />
      </div>
      <div class="rightBox">
        <div class="tankName">{{ detail.name }}</div>
        <div class="infoBox">
          <a-descriptions :column="2">
            <a-descriptions-item label="行业分类">
              <dict-render :dict-obj="dictObjs['research_field']" v-if="detail.applicationIndustry"
                :text="detail.applicationIndustry"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="技术领域">
              <dict-render :dict-obj="dictObjs['trading_technologyType']" v-if="detail.technoSphere"
                :text="detail.technoSphere"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="交易方式">
              <dict-render :dict-obj="dictObjs['trading_method']" v-if="detail.cooperationWay"
                :text="detail.cooperationWay"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="成熟度">
              <dict-render :dict-obj="dictObjs['technical_maturity']" v-if="detail.techMaturity"
                :text="detail.techMaturity"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="发布时间">
              {{ detail.createdTime ? detail.createdTime.split(' ')[0] : '' }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </div>
    <!-- <div class="tutorBox">
      <div class="tankName">{{ detail.name }}</div>
      <div class="infoBox">
        <a-descriptions :column="3">
          <a-descriptions-item label="技术领域">
            <dict-render :dict-obj="dictObjs['belong_techField']" v-if="detail.technoSphere"
              :text="detail.technoSphere"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="应用行业" :span="2">
            <dict-render :dict-obj="dictObjs['research_field']" v-if="detail.applicationIndustry"
              :text="detail.applicationIndustry"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="成果图片">
            <img-upload v-model:value="detail.achievementPicture" :showBtn="false" :disabled="true" />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div> -->
    <!-- <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            成果摘要
          </div>
        </div>
        <div class="talentContentBox">
          {{ detail.achievementAbstract }}
        </div>
      </div>
    </div> -->
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            成果简介
          </div>
        </div>
        <div class="talentContentBox">
          {{ detail.achievementSynopsis }}
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { tableListMixin, dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import { achievementFontInfo } from "@/api/achievementsService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: "noticeDetail",
  components: { AchievementsHeader, DictRender, LayoutFooter },
  mixins: [tableListMixin, dictMixin],
  data() {
    return {
      dictNames: 'trading_technologyType,research_field,trading_method,technical_maturity',
      companyJobList: {},
      detail: {},
      ellipsis: true,
      isUserCode: false,
      type: null,
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: achievementFontInfo.tradeDetail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.detail = res
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/achievements/components/achievementRequirements",
        query: { type: '成果交易', tab: '1' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/achievements/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
  },
  mounted() {
    this.getDetail()
    this.type = this.$route.query.type
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  // background: white;
}

.tradingBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .leftBox {
    float: left;
    width: 20%;
    height: 160px;

    :deep(.ant-image) {
      width: 100%;
      height: 100%;

      :deep(.ant-image-img) {
        width: 100%;
        height: 100%;
      }
    }
  }

  .rightBox {
    float: right;
    width: 76%;

    .tankName {
      margin-bottom: 18px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }

    .infoBox {
      padding: 20px 0;
      font-size: 14px;
      color: #666;
    }
  }
}

.tutorBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .tankName {
    margin-bottom: 18px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .infoBox {
    position: relative;
    padding: 20px;
    background-color: #ecf0f6;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;

    .grayBox {
      position: absolute;
      right: 5%;
      bottom: 30%;
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;
  background-color: #fff;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }
    }

    .talentContentBox {
      padding: 14px 20px;
      width: 100%;
      text-indent: 2em;
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #333;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #333;
}
</style>
